import * as React from 'react';
import { AppBadge, APP_BADGE_GOOGLE_PLAY_PROPS, APP_BADGE_PROPS_IOS } from './AppBadge';
import { useMobileSetting } from 'src/hooks/useMobileSetting';
import { Link } from './Link';
import { locale, text } from 'src/common/text';

const FooterRow: React.FC<{ style?: React.CSSProperties }> = ({ children, style }) => (
  <div style={{ display: 'flex', flexDirection: 'row', ...style }}>{children}</div>
);

const FooterColumn: React.FC<{ style?: React.CSSProperties }> = ({ children, style }) => (
  <div style={{ flex: '1 1 0px', display: 'flex', flexDirection: 'column', ...style }}>{children}</div>
);

export const Footer: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const { showLanding } = useMobileSetting();
  const showAppDownload = !showLanding;
  const privacyPolicyLink = locale === 'de' ? 'https://www.untis.at/datenschutz-wu-apps' : 'https://www.untis.at/en/privacy-policy-wu-apps';

  return (
    <footer
      style={{
        width: '100%',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        ...style,
      }}
    >
      {showAppDownload && (
        <FooterRow
          style={{
            paddingBottom: 24,
          }}
        >
          <FooterColumn style={{ alignItems: 'flex-end' }}>
            <AppBadge {...APP_BADGE_PROPS_IOS} />
          </FooterColumn>
          <div style={{ width: 16, height: 16 }} />
          <FooterColumn style={{ alignItems: 'flex-start' }}>
            <AppBadge {...APP_BADGE_GOOGLE_PLAY_PROPS} />
          </FooterColumn>
        </FooterRow>
      )}
      <FooterRow
        style={{
          paddingBottom: 16,
        }}
      >
        <FooterColumn style={{ alignItems: 'flex-end' }}>
          <Link target="_blank" href="https://www.untis.at/impressum">
            {text('LBL_IMPRESS')}
          </Link>
        </FooterColumn>
        <div style={{ width: 16, height: 16 }} />
        <FooterColumn style={{ alignItems: 'flex-start', flexGrow: 0, whiteSpace: 'nowrap' }}>
          <Link target="_blank" href={privacyPolicyLink}>
            {text('LBL_LEGAL')}
          </Link>
        </FooterColumn>
        <div style={{ width: 16, height: 16 }} />
        <FooterColumn style={{ alignItems: 'flex-start' }}>
          <Link target="_blank" href="https://jobs.untis.at">
            {text('LBL_JOBS_AT_UNTIS')}
          </Link>
        </FooterColumn>
      </FooterRow>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/components/Footer.tsx